import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'




import BoxButton from '../Layout/BoxButton'
import General from '../Documentos/General'
import Aprobacion from '../Documentos/Aprobacion'
import DocumentosAsociados from '../Documentos/DocumentosAsociados'
import Entregas from '../Documentos/Entregas'
import Adiciones from '../Documentos/Adiciones'
import Facturas from '../Documentos/Facturas'

import Cancelacion from '../Documentos/Cancelacion'

import {
    showHideModalSummary,
    showHideModalAddAdicional,
    cancelDocumento,
    updateDocumento
} from '../../actions/documentos'

import {
    showHideModalAddFactura, showModalConfirmarAccion
} from '../../actions/common'



import {
    isAllowedToViewComponent
} from '../../utils/helpers'

class ModalSummary extends Component {
	constructor(props) {
		super(props)

        let tabs = [
            { id: 0, caption: 'Documento', component: <General disabledAttach reducer={ 'solicitudservicioot' } />, estado: 0 },
            { id: 1, caption: 'Aprobación', component: <Aprobacion />, estado: 0 },
            { id: 2, caption: 'Documentos asociados', component: <DocumentosAsociados />, estado: 1 },
            { id: 3, caption: 'Ajustes', component: <Adiciones />, estado: 0 },
            { id: 4, caption: 'Entregas', component: <Entregas />, estado: 0 },
            { id: 5, caption: 'Facturas', component: <Facturas />, estado: 6 },
            { id: 6, caption: 'Cancelación', component: <Cancelacion />, estado: 0 },
        ]

        if (props.modalSummary.getIn(['data','estado']) === 6 && !props.modalSummary.get('documentos')) delete tabs[2]
        if (props.modalSummary.getIn(['data','estado']) === 6 && !props.modalSummary.get('adiciones')) delete tabs[3]

        if (props.tipo_solicitud === 5) {
            delete tabs[2]
            delete tabs[3]
            delete tabs[4]
            delete tabs[5]
            delete tabs[6]
        }

		this.state = {
			tabs: [...tabs],
			selected: 0,
            maximised: false
		}
	}

    handleCloseModal = () => {
        const modal = document.getElementById('modalSummary')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSummary .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        this.setState({ maximised: false, selected: 0 })
        setTimeout(() => this.props.showHideModalSummary(false), 300)
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    

    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar este documento?`, () => { this.props.showModalConfirmarAccion(false); this.props.cancelDocumento()})
    }    



    render() {

		const { tabs, selected, maximised } = this.state
        const { modalSummary, user, enums, documento_origen } = this.props
        
        if (!modalSummary.get('show')) {
            return null
        }

        const documento = modalSummary.get('data')
        const readOnly = (documento_origen != null)
        const editar = modalSummary.get('editar')
        

        return(
            <Modal id="modalSummary" show={ true } ZIndex={ 2000 } draggable={ !maximised }>
                <ModalHeader title={ <span style={{ fontWeight: (maximised) ? 'bold' : 'normal' }}>{`Documento: ${enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].NOMBRE} ${enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].PREFIJO}${modalSummary.getIn(['data', 'consecutivo'])}` }</span> } onClose={ e => this.handleCloseModal(e, "modalSummary") } />
                <ModalButtonStrip>

                    <BoxButton
                        name={ maximised ? 'compress' : 'arrows-alt' }
                        title={ maximised ? 'Minimizar' : "Maximizar" }
                        onClick={ e => this.setState({ maximised: !maximised }) }
                    />

                    {
                        (this.state.selected === 0 &&
                        isAllowedToViewComponent('responsable_compras', documento.get('solicitude')) &&
                            <BoxButton
                                name="floppy-o"
                                title="Actualizar documento"
                                onClick={ () => this.props.updateDocumento() }
                                disabled={ !editar }
                            />
                        )
                    }  



                    {
                        (this.state.selected === 3 &&
                        isAllowedToViewComponent('responsables_recibo', documento, user.get('id')) &&
                            <BoxButton
                                name="plus-circle"
                                title="Crear adición"
                                onClick={ e => this.props.showHideModalAddAdicional(true, documento.get('id'), modalSummary.get('url'), modalSummary.get('type')) }
                                disabled={readOnly}
                            />
                        )
                    }                  



                    {
                        (this.state.selected === 6 &&
                            <BoxButton
                                name="ban"
                                title="Cancelar orden/contrato"
                                onClick={ e => this.cancel() }
                                disabled={ documento.get('estado') == 0 }
                            />
                        )
                    }



                </ModalButtonStrip>
                <ModalBody>
                    <div className={ this.state.maximised ? 'modal-100-100' : 'modal-80-70' }>
                        <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                            <div className="col-md-12" style={{ height: '100%' }}>
                                <div className="nav-container">
                                    <div className="nav-tabs-section">
                                        <ul className="nav-tabs-tabs green">
                                            {
                                                tabs.filter(x => x.estado <= documento.get('estado')).map(x => {

                                                    //const entregado = documento.get('entregas').count() > 0 ? documento.get('entregas').filter(e => e.get('recibido') == 1).count() > 0 : false
                                                    //if (entregado && x.id == 6) return null
                                                    
                                                    if (documento.get('estado') == 11 && x.id == 6) return null

                                                    return (
                                                        <li key={ `li02[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                            <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    <div className="nav-main-section">
                                        <div className="nav-main-section-scrollable">
                                            { tabs[selected].component }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSummary: state.documentos.get('modalSummary'),
        user: state.common.get('user'),
        enums: state.common.get('enums').toJS(),
        documento_origen: state.solicitudservicioot.getIn(['solicitud', 'documento_origen']),
        tipo_solicitud: state.solicitudservicioot.getIn(['solicitud', 'tipo'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalSummary: (state) => dispatch(showHideModalSummary(state)),
        showHideModalAddFactura: (show, documento, url, type) => dispatch(showHideModalAddFactura(show, documento, url, type)),
        showHideModalAddAdicional: (show, documento, url, type) => dispatch(showHideModalAddAdicional(show, documento, url, type)),
        cancelDocumento: () => dispatch(cancelDocumento()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        updateDocumento: () => dispatch(updateDocumento()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSummary)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicioOT/ModalSummaryDocumento.jsx